'use client';

import { SnackbarProvider } from 'notistack';
import Snackbar from './Snackbar';

const SnackbarWrapper = ({ children }: any) => (
    <SnackbarProvider 
    maxSnack={3}
    anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
    }}
    >
        <Snackbar>
            {children}
        </Snackbar>
    </SnackbarProvider>
);

export default SnackbarWrapper;